import React, { useState } from 'react';
import {  HollowDotsSpinner } from 'react-epic-spinners';
import AccountServices from "../../services/AccountServices";
import fire from './../../utils/Toastr';


export default function MandateUploadButton({ accountNumber, adminType }) {
    const [mandateLoader, setMandateLoader] = useState({ loader: false });
  
    const uploadMandate =async (accountNumber) => {
      setMandateLoader({ loader: true });
      // your upload logic here
      const resp = await AccountServices.uploadMandate({accountNumber:accountNumber});
   
      if (resp) {
        fire("success", resp.message);
        setTimeout(() => {
          window.location.reload();
        }, 4000);
      }
      setMandateLoader({ loader: false, accountNumber:accountNumber });
    };
  
    return (
      <div className="mt-5">
        {mandateLoader.loader === false ? (
          <button
            type="button"
            onClick={() => uploadMandate(accountNumber)}
            className="block py-3 px-5 text-sm text-gray-700 text-left bg-red-100 border-gray-300 rounded-md"
          >
            {adminType.toLowerCase() === "maker"
              ? "Initiate Mandate Upload"
              : "Approve Mandate Upload"}
          </button>
        ) : (
          <HollowDotsSpinner size={20} color="#4D627E" />
        )}
      </div>
    );
  }